/* global globalThis */
/**
 * Волна 36: рынок политик у ботов «золото+» (бонус «большой» и выше, см.
 * configs/botGoldPlus и utils/bots/evaluation/goldPlus).
 *
 * Откуда. Прод-реплеи 27.10 (zml5bhz, z3lg8hs, w0gn7gj, f7l8kys): 14 ботов
 * золото+ ни разу не обновили рынок, 6 из них сидели без политики 5–8 раундов
 * (47 бот-раундов без политики и без покупки); по архиву с 05.10 — 1588 ходов
 * стройки R1–6 без политики, в 977 из них осталось хотя бы одно действие.
 * Обновление стоит одно действие строительства и 0 монет, а боты используют
 * в среднем 3.1–4.3 из 5.2–5.6 действий хода.
 *
 * Подчасти (каждая — за своим legacy-гейтом A/B в utils/bots/abTestGates.js):
 *  PT — цели золото+: топ-3 фракции (getW36GoldTopPolicies) — первые в ранге
 *       ценности, покупаются и из дорогого слота; вне вайтлиста волны 30 —
 *       только Теократия по решению владельца (configs/botGoldPlus);
 *  PR — обновление, пока политики нет и купить с рынка нечего;
 *  PW — обновление вместо покупки слабой политики (не из топ-3);
 *  PX — обновление ради замены слабой текущей политики на цель из топ-3.
 * Решения — utils/bots/decisions/decidePolicyStep.js
 * (findBotPolicyMarketRefreshReason, decidePolicyMarketRefreshStep).
 *
 * Ручки последних раундов подчастей читают переопределение из globalThis (в
 * продакшене не задано) — для калибровки в харнессе без пересборки.
 */

// Причины обновления рынка (для журнала харнесса и тестов)
export const W36_MARKET_REFRESH_REASONS = {
  // PR: политики нет, а купить с текущего рынка нечего
  NO_POLICY: 'no_policy',
  // PW: политики нет, купить можно только не-цель, а цель из топ-3 жизнеспособна
  OVER_WEAK: 'over_weak',
  // PX: текущая политика не из топ-3, и цель из топ-3 заметно ценнее ее
  REPLACE: 'replace',
};

// PR: последний раунд обновления «без политики». Откуда 6: первая покупка у
// ботов золото+ на реплеях приходится на R1–R9 (медиана R5–6), по архиву бот
// сидит без политики 3.3 хода из R1–6; по R5 включительно действует ранний
// запрет Экоанархизма (configs/botEarlyForbiddenPolicies), с R4 растет
// послабление «засиделся без политики» (calcNoPolicyPriceRelief) — к R6 оно
// уже пропускает почти любой разрешенный слот, и дальше действие стройки
// ценнее обновления. Переопределение для калибровки:
// globalThis.__w36MarketRefreshLastRound
export const W36_MARKET_REFRESH_LAST_ROUND = 6;

// PW: последний раунд, когда бот без политики сначала обновляет рынок, а не
// берет слабую доступную. Откуда 5: последний раунд раннего запрета
// Экоанархизма — у четырех фракций он в топ-3 и раньше R6 недоступен, а с R4
// послабление цены и так толкает к покупке; позже ждать цель дороже, чем
// держать слабую политику (ее потом заменит PX).
// Переопределение: globalThis.__w36RefreshOverWeakLastRound
export const W36_REFRESH_OVER_WEAK_LAST_ROUND = 5;

// PX: последний раунд обновления ради замены текущей политики. Откуда 8:
// последний раунд армейской фазы волны 33 (isBonusArmyPhase); замена у
// не-людей вступает с конца раунда (редьюсер BUY_POLICY), так что при лимите
// 13 раундов новая политика действует еще 5 раундов — ниже окупаемость
// цены слота и действия на обновление сомнительна.
// Переопределение: globalThis.__w36PolicyReplaceLastRound
export const W36_POLICY_REPLACE_LAST_ROUND = 8;

// Сколько действий строительства должно остаться ПОСЛЕ обновления (оно само
// тратит одно). Откуда 1: обновление не должно съедать последнее действие —
// иначе ход без построек ради одной политики (спецификация волны 36)
export const W36_MARKET_REFRESH_MIN_ACTIONS_LEFT = 1;

// Монет на покупку (тратимых — за вычетом резервов, как в findBotPolicyToBuy)
// должно хватать хотя бы на слот с этим индексом. Откуда 2: середина рынка из
// 6 слотов — третий слот, цена 3 (у людей со скидкой 0). Цель из топ-3 после
// обновления лежит в слотах 1–3 с шансом 1-(1-k/15)^3 (k — число целей),
// для трех целей ~49%; беднее — обновление почти всегда впустую
export const W36_MARKET_REFRESH_MIN_AFFORDABLE_SLOT_INDEX = 2;

// Имена глобалов-переопределений, которые читают геттеры ниже, — для проверки
// ручек харнесса (SIM_W36_KNOBS в server/scripts/simulateBotBatch.js: имя вне
// списка — ошибка, а не молча действующий дефолт). Новая ручка — сюда же
export const W36_POLICY_MARKET_KNOB_GLOBALS = [
  '__w36MarketRefreshLastRound',
  '__w36RefreshOverWeakLastRound',
  '__w36PolicyReplaceLastRound',
];

const readRoundOverride = (name, fallback) => {
  const override = globalThis[name];
  return typeof override === 'number' && Number.isFinite(override) ? override : fallback;
};

export const getW36MarketRefreshLastRound = () => readRoundOverride(
  '__w36MarketRefreshLastRound', W36_MARKET_REFRESH_LAST_ROUND
);

export const getW36RefreshOverWeakLastRound = () => readRoundOverride(
  '__w36RefreshOverWeakLastRound', W36_REFRESH_OVER_WEAK_LAST_ROUND
);

export const getW36PolicyReplaceLastRound = () => readRoundOverride(
  '__w36PolicyReplaceLastRound', W36_POLICY_REPLACE_LAST_ROUND
);
